//@ts-ignore
import { tw } from "@careinfo/tailwind";

export default function Overview() {
  return <div className={tw`h-fit`}>Overview</div>;
}
